{
  "title": "File d'attente de dérive",
  "tabs": {
    "needsAction": "Nécessite une action",
    "singleBreach": "Infraction unique",
    "compoundBreach": "Infraction composée"
  },
  "table": {
    "portfolio": "Portefeuille",
    "household": "Ménage",
    "accountType": "Type de compte",
    "reason": "Raison",
    "custodian": "Dépositaire",
    "value": "Valeur",
    "cashAndPosition": "Compte de trésorerie / Position",
    "cashShort": "Trésorerie",
    "positionShort": "Pos.",
    "staleTooltip": "Données périmées — en date du {{date}}",
    "positionUnavailable": "Dérive de position non disponible"
  },
  "empty": {
    "title": "Aucun compte ne nécessite d'action aujourd'hui.",
    "filterNoResults": "Aucun compte ne correspond à ce filtre."
  },
  "footer": {
    "rowCount": "Affichage de {{shown}} des {{total}} comptes nécessitant une action"
  },
  "legend": {
    "title": "Légende",
    "singleBreach": "Infraction unique",
    "compoundBreach": "Infraction composée",
    "stale": "Données périmées",
    "international": "Placements internationaux"
  },
  "lastRefresh": {
    "label": "En date du {{value}}"
  },
  "header": {
    "queueAlertLabel": "{{count}} en file d'attente",
    "queueAlertA11yLabel": "{{count}} comptes dans la file d'attente d'actions",
    "viewAll": "Voir tout"
  },
  "breaches": {
    "liquidation": "Liquidation",
    "transfer": "Transfert",
    "drift": "Dérive",
    "unverified_one": "{{count}} Non vérifié(s)",
    "unverified_other": "{{count}} Non vérifié(s)",
    "pending_one": "{{count}} En attente",
    "pending_other": "{{count}} En attente"
  }
}
